(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/components/dialog/assets/javascripts/dialog-queue.js') >= 0) return;  svs.modules.push('/components/components/dialog/assets/javascripts/dialog-queue.js'); "use strict";

(function (svs) {
  'use strict';

  svs = svs || {};
  svs.components = svs.components || {};
  svs.components.dialog = svs.components.dialog || {};

  class DialogQueue extends svs.components.dialog.PubSub {
    constructor(options) {
      super();
      this.log = new svs.core.log.Logger('DialogQueue');
      this.options = options;
      this.areas = {};
      this.at = 0;
    }

    addEventListeners(area) {
      area.on('open', this, () => {
        this.emit('showDimmer');
      });
      area.on('close', this, () => {
        const popupCount = this.areas && this.areas[svs.components.dialog.area.POPUP] && this.areas[svs.components.dialog.area.POPUP].count();
        const toasterCount = this.areas && this.areas[svs.components.dialog.area.TOASTER] && this.areas[svs.components.dialog.area.TOASTER].count();
        const contextualCount = this.areas && this.areas[svs.components.dialog.area.CONTEXTUAL] && this.areas[svs.components.dialog.area.CONTEXTUAL].count();

        if (this.count() === 0) {
          this.log.debug('Nothing more to show, remove all');
          this.emit('hideDimmer');
        } else if (popupCount === 0 && (toasterCount > 0 || contextualCount > 0)) {
          this.emit('hideDimmer');
        }
      });
      area.on('changed', this, options => {
        this.emit('changed', options);
      });
    }

    close() {
      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          area.close();
        }
      }
    }

    closeFromOutside(e) {
      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];

          if (area.closeFromOutside) {
            area.closeFromOutside(e);
          }
        }
      }
    }

    add(dialog) {
      const dialogArea = dialog.options.area;

      if (dialogArea === svs.components.dialog.area.TOASTER && !dialog.options.convertToPopup && Boolean(this.areas.popup && this.areas.popup.items && this.areas.popup.items.length > 0)) {
        this.log.debug("Do not add toaster with title ".concat(dialog.options.title || '[not set]', " to queue because there is already popups in queue and this toaster has convertToPopup set to false"));
      } else {
        if (!this.areas[dialogArea]) {
          this.areas[dialogArea] = new svs.components.dialog.areas[dialogArea]({
            attachTo: this.options.attachTo,
            areas: this.areas
          });
          this.addEventListeners(this.areas[dialogArea]);
        }

        this.log.debug('Added a dialog to queue');
        this.areas[dialogArea].add(dialog);
        this.log.debug(this.count());
        this.emit('added', dialog);
      }
    }

    count() {
      let itemsInQueue = 0; 

      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          itemsInQueue += area.items.length;
        }
      }

      return itemsInQueue;
    }

    status() {
      let msg = ''; 

      for (const areaKey in this.areas) {
        if (Object.prototype.hasOwnProperty.call(this.areas, areaKey)) {
          const area = this.areas[areaKey];
          msg = "".concat(area.name, " queue, ").concat(area.items.length, " still remain");
        }
      }

      this.log.debug(msg);
    }

  }

  svs.components.dialog.DialogQueue = DialogQueue;
})(svs);
 })(window);